import { render, staticRenderFns } from "./OrderDiscountsTable.vue?vue&type=template&id=656deb04&"
import script from "./OrderDiscountsTable.vue?vue&type=script&lang=js&"
export * from "./OrderDiscountsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderDiscountsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports